export default {
  ja_jp: {
    bannerImg: 'jp.png',
    umText: 'まもなく登場',
    requiredLogin: 'このゲームにはログインする必要があります',
    jackpotId_1: {
      name: '神話の宝ジャックポット',
      level1Jackpot: 'グランド',
      level2Jackpot: 'メガ',
      level3Jackpot: 'マックス',
    },
    jackpotId_2: {
      name: 'フラフィージャックポット',
      level1Jackpot: 'メガ',
      level2Jackpot: 'マックス',
      level3Jackpot: 'ミニ'
    },
    jackpotId_3: {
      name: 'ゴールデンリッチェズジャックポット',
      level1Jackpot: 'グランド',
      level2Jackpot: 'メジャー',
      level3Jackpot: 'マイナー',
      level4Jackpot: 'ミニ',
    }
  },
};
